/* A recording, and the script it was read from.

   The script is the material and is always here; the recording may not be. So
   the script is what the component is built around and the player sits above
   it, appearing only if there is something to play. A lesson whose audio has
   not been made yet is not a broken page — it is a lesson with a text somebody
   can read aloud.

   `preload="none"` on purpose. Ten lessons open in a browser must not fetch ten
   recordings nobody pressed play on, and on a school connection the difference
   is the whole page.

   Whether a recording exists is answered by asking for it, not by a second
   endpoint that says so: the player reports an error and the player disappears.
   One request either way.

   OWNED BY ITEM 6 OF PLAN.md. */

import { useEffect, useState } from "react";
import { T } from "./shared";
import { useI18n } from "../lib/i18n";
import type { Localized } from "../lib/types";

/* The recording is the one thing the portal reads from the database rather than
   from a file, so it has one address in both environments — the API's. */
export const mediaUrl = (slug: string) => `/api/media/${encodeURIComponent(slug)}`;

export function Audio({ audio, script, minutes }: {
  audio?: string; script: Localized; minutes?: number;
}) {
  const { ui } = useI18n();
  const [missing, setMissing] = useState(false);

  useEffect(() => { setMissing(false); }, [audio]);

  return (
    <div className="lesson-audio">
      {audio && !missing ? (
        <audio className="lesson-player noprint" controls preload="none"
               src={mediaUrl(audio)} onError={() => setMissing(true)}>
          {ui("audio.noPlayer")}
        </audio>
      ) : null}

      <div className="box-label">
        {ui("lesson.script")}
        {minutes ? <span className="lesson-mins">{minutes} {ui("lesson.minutes")}</span> : null}
      </div>
      <div className="lesson-script"><T value={script} block /></div>
    </div>
  );
}
